import { render } from "./PaymentMethod.vue?vue&type=template&id=6415d47c&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=6415d47c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6415d47c"

export default script